export const ERRORS = {
  INSUFFICIENT_BALANCE: `Insufficient balance`,
  INSUFFICIENT_LIQUIDITY: `Insufficient AMM liquidity for this trade`,
  LESS_MARGIN: `Total margin should be greater than Min. Collateral`,
  SOFT_LIMIT: `Positions in the vault will exceed vault soft limit`,
  CONNECT_NETWORK: `Please connect wallet`,
  SUBVAULTS_ARE_LOADING_NOW: `Positions are being loaded now`
} as const
